import PeriodTitle from '../reusablesComponent/periodTitle';

/**
 * Componente que muestra los puntajes de un evento deportivo general
 * Renderiza los scores de ambos equipos con indicadores visuales de ganador
 * Incluye funcionalidad de click para navegar a estadísticas detalladas
 * 
 * @param {Object} props - Propiedades del componente
 * @param {Array} props.rightBlockClasses - Clases CSS para el contenedor de puntajes
 * @param {Object} props.item - Datos del evento deportivo
 * @param {string} props.item.left_score - Puntaje del equipo local
 * @param {string} props.item.left_class - Clase que indica si el equipo local ganó
 * @param {string} props.item.right_score - Puntaje del equipo visitante
 * @param {string} props.item.right_class - Clase que indica si el equipo visitante ganó
 * @param {Function} props.norm - Función para normalizar strings
 * @param {Function} props.clickScore - Función callback para manejar clicks en los puntajes
 * 
 * @returns {JSX.Element} Contenedor con puntajes y indicadores de ganador
 */
export default function ScoreGeneralComponent({
  rightBlockClasses,
  item,
  norm,
  clickScore,
  clase,
  opta_event_url,
  period_title,
  utc_date,
  time_format,
  isTenis,
  tenis_fase,
  gameClass,
  isErrorGame
}) {

  // Destructuring para mejor legibilidad
  const { left_score, left_class, right_score, right_class, left_red_card, right_red_card } = item;

  /**
   * Determina si un equipo es ganador basado en su clase
   * @param {string} teamClass - Clase del equipo
   * @returns {boolean} True si el equipo es ganador
   */
  const isWinner = (teamClass) => {
    return norm(teamClass).toLowerCase() === "clarosports-winner";
  };

  /**
   * Componente reutilizable para mostrar el puntaje de un equipo
   * @param {Object} props - Propiedades del componente
   * @param {string} props.score - Puntaje del equipo
   * @param {string} props.teamClass - Clase que indica si ganó
   * @param {string} props.teamType - Tipo de equipo (local/visitante)
   */
  const ScoreBox = ({ score, teamClass, teamType, redCard, section }) => {
    const normalizedScore = norm(score).toLowerCase();
    const className = isWinner(teamClass) ? "card-general-score-winner" + section : "card-general-score" + section;

    return (
      <div className={className} aria-label={`Puntaje ${teamType}: ${normalizedScore}`} >
        {/* {redCard ? <div className="flag-red"></div> : <div className='flag-none'></div>} */}
        {redCard ? <div className="flag-red-results"></div> : <div className='flag-none'></div>}
        <p>{normalizedScore}</p>
      </div>
    );
  };

  return (
    <div
      className={rightBlockClasses.join(" ")}
      onClick={clickScore}
      role="button"
      tabIndex={0}
      aria-label="Ver estadísticas detalladas del partido"
      title="Click para ver más información"
    >
      {/* Puntaje equipo local */}
      {(gameClass !== "clarosports-next-game" && !isErrorGame) &&
        <ScoreBox score={left_score} teamClass={left_class} teamType="local" redCard={left_red_card} section={" score-left"}/>
      }

      {clase === 'clarosports-next-game' &&
        <PeriodTitle
          clase={clase}
          opta_event_url={opta_event_url}
          period_title={period_title}
          utc_date={utc_date}
          time_format={time_format}
          isTenis={isTenis}
          tenis_fase={tenis_fase}
        />
      }

      {/* Puntaje equipo visitante */}
      {(gameClass !== "clarosports-next-game" && !isErrorGame) &&
        <ScoreBox score={right_score} teamClass={right_class} teamType="visitante" redCard={right_red_card} section={" score-right"}/>
      }
    </div>
  );
}